import { render } from "./tourDetail.vue?vue&type=template&id=1cb18c59"
import script from "./tourDetail.vue?vue&type=script&lang=js"
export * from "./tourDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__